import { UI_RULES, UIBehavior } from "./uiVisibilityRules";

const BEHAVIOR_CSS: Record<UIBehavior, string> = {
  hidden: "display: none !important;",
  disabled: "pointer-events: none !important; opacity: 0.5 !important;",
};

export function generateModeCss(): string {
  let css = "";
  for (const mode in UI_RULES) {
    for (const id in UI_RULES[mode]) {
      const behavior = UI_RULES[mode][id];
      css += `[data-app-mode="${mode}"] #${id} { ${BEHAVIOR_CSS[behavior]} }\n`;
    }
  }
  return css;
}
